import { IDeliveryContact } from "app/shared/Domains/deliveryContact";
import { IProduct } from "./IProduct";
import { SoldTo } from "app/shared/Domains/soldTo";
import { Ingredients } from "./Ingredients";
import { PayLater } from "./PayLater";


export class SaleOrder {
   _id: string;
   invoiceNumber: number;
   orderNumber: string;
   quoteNumber: string;
   orderDate: Date;
   quoteDate: Date;
   invoiceDate: Date;
   isSalesQuote: boolean;
   isRequested: boolean;
   // customer: ICustomer;
   salesRep: string;
   location: string;
   remarks: string;
   taxingScheme: string;
   pricingScheme: string;
   modeOfPayment: string;
   nonCustomerCost: number;
   subTotal: number;
   tax: number;
   total: number;
   returnTotal: number;
   paid: number;
   returned: number;
   balance: number;
   returnBalance: number;
   freightcharge: number;
   remainingBalance: number;
   finalReceivedAmount: number;
   orderStatus: string;
   // paymentDetails: IPaymentDetail[];
   // returnDetails: IReturnDetail[];
   products: IProduct[];
   // fulfill: IFulFill;
   // return: IReturn;
   // restock: IRestock;
   // files: IFile[];
   // pick: IPick;
   // ship: IShip;
   term: string;
   PONumber: string;
   dueDate: Date;
   isConverted: boolean;
   isBalance: boolean;
   isReturnBalance: boolean;
   isCash: boolean;
   LastCashPaymentcradit: boolean;
   vatTax: number;
   company: string;
   branch: string;
   discountType: number;
   discount: number;
   createdBy: string;
   remainingSubtotal: number;
   amountPayedInPaymentDetails: number;
   amountPayedInReturnDetails: number;
   deliveryContactDetails: IDeliveryContact;
   isDeliveryEnabled: boolean;
   isPaymentAndReciept: boolean;
   status: string;
   soldTo: SoldTo;
   payLater?: PayLater;
   ingredients: Ingredients[];
}